import React from 'react';
import { matches } from './MediaQuery';
import MediaQuery from './MediaQuery';

export default function withMediaQuery(query) {
  return function(Component) {
    return class ComponentWithMediaQuery extends React.Component {
      state = {
        matches: matches(query),
      };

      boundOnMediaChange = this.onMediaChange.bind(this);

      onMediaChange(matches) {
        this.setState({
          matches,
        });
      }

      render() {
        return (
          <React.Fragment>
            <Component mediaQueryMatches={this.state.matches} {...this.props} />
            <MediaQuery
              mediaQuery={query}
              onMediaChange={this.boundOnMediaChange}
            />
          </React.Fragment>
        );
      }
    };
  };
}
